/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagGroupList } from '../../models/tag-group-list';
import { TagGroupSearch } from '../../models/tag-group-search';

export interface SearchTagGroupByTagGroupType$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;
  
    /**
     * Body for search tag group by type
     */
    body: TagGroupSearch
}

export function searchTagGroupByTagGroupType(http: HttpClient, rootUrl: string, params: SearchTagGroupByTagGroupType$Params, context?: HttpContext): Observable<StrictHttpResponse<TagGroupList>> {
  const rb = new RequestBuilder(rootUrl, searchTagGroupByTagGroupType.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagGroupList>;
    })
  );
}

searchTagGroupByTagGroupType.PATH = '/tag-group-types/tag-groups/search';
